"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Device Binding Service API definition
 * This is the REST API for the Device Binding Service (DBS).
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: convergent-dev@tivo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorSamlTokenCodeEnum = void 0;
exports.ErrorSamlTokenCodeEnum = {
    BadRequestParameters: 'DBS.BAD_REQUEST_PARAMETERS',
    ResourceNotFound: 'DBS.RESOURCE_NOT_FOUND',
    DbsInvalidLicenseplate: 'DBS.DBS.INVALID_LICENSEPLATE',
    ExpiredLicenseplate: 'DBS.EXPIRED_LICENSEPLATE',
    NotAuthorized: 'DBS.NOT_AUTHORIZED',
    GaError: 'DBS.GA_ERROR',
    DynamodbError: 'DBS.DYNAMODB_ERROR',
    IntegrationTimeout: 'DBS.INTEGRATION_TIMEOUT'
};
